// removed by extract-text-webpack-plugin
module.exports = {"h2style":"h2style__3aYf1","aboutcurrency-wrapper":"aboutcurrency-wrapper__GHcUl"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/Aboutcurrenies/Aboutcurrenies.scss
// module id = 727
// module chunks = 68